var MAX_HISTORY_ITEMS = 10;
var MAX_SUGGESTIONS_MAP = {
    History: 2,
    WordSearch: 4,
    Entity: 4};
var SEARCHBAR_DEFAULT_DROPDOWN = [
    {
        key: 'App',
        text: 'Apps',
        gallery: 'AppsourceApps'
    },
    {
        key: 'Service',
        text: 'Consulting Services',
        gallery: 'AppsourceConsultingServices'
    },
    {
        key: 'CloudsIndustry',
        text: 'Industry Clouds'
    },
    {
        key: 'Partner',
        text: 'Partners',
        gallery: 'Partners'
    }
];
var UNIFIED_SEARCHBAR_DROPDOWN = [
    {
        key: 'App',
        text: 'Products',
        gallery: 'AppsourceApps'
    },
    {
        key: 'Service',
        text: 'Professional Services',
        gallery: 'AppsourceConsultingServices'
    },
    {
        key: 'CloudsIndustry',
        text: 'Industry Clouds'
    },
    {
        key: 'Partner',
        text: 'Partners',
        gallery: 'Partners'
    }
];
var SEARCHBAR_DEFAULTS = {
    DROPDOWN: SEARCHBAR_DEFAULT_DROPDOWN};

export { MAX_HISTORY_ITEMS, MAX_SUGGESTIONS_MAP, SEARCHBAR_DEFAULTS, UNIFIED_SEARCHBAR_DROPDOWN };
